// src/firebase.js for sipnscore-customer
// ---------------------------------------------------------------------------
// Two Firebase products, not five.
//
// This file used to initialise Auth, Storage and Analytics as well. None of the
// three was imported anywhere: there is deliberately no guest authentication
// (see CLAUDE.md), nothing in the guest flow uploads a file, and analytics was
// never read. All three shipped in the bundle and Analytics also fired a network
// request during the first paint, on a phone, on a bar's wifi, while a guest was
// waiting for a screen.
//
// If you need one of them back, import it where it is used rather than here.
// ---------------------------------------------------------------------------
import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAKoQci34j8FwpMudniXie6jHcg856P42Q",
  authDomain: "sipnscore-2e005.firebaseapp.com",
  projectId: "sipnscore-2e005",
  // Kept in step with the portal, though nothing here reads it: this app never
  // initialises Storage. Two configs that disagree are a trap for whoever
  // eventually does need it here.
  storageBucket: "sipnscore-2e005-za",
  messagingSenderId: "118879175876",
  appId: "1:118879175876:web:5238276cbcac4c29b67591",
  measurementId: "G-T67T54LF6D",
};

const app = initializeApp(firebaseConfig);

// `initializeFirestore` rather than `getFirestore`, for one setting.
//
// Firestore listens over a streaming connection by default. Plenty of the
// networks this app runs on cannot carry one: mobile data through a carrier
// proxy, a bar's captive-portal wifi, a corporate guest network. On those the
// SDK opens the stream, waits for it to fail, and only then falls back to long
// polling, and the wait is a fixed timeout measured in seconds during which the
// screen says "Loading questions...".
//
// autoDetectLongPolling makes that decision from the first response instead of
// from a timeout. On a good connection it changes nothing; on a bad one it is
// the difference between a pause and a guest putting their phone away.
const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});

// Callable functions are deployed to Johannesburg. This must match the region
// set in the admin project's functions/index.js or every call 404s.
export const FUNCTIONS_REGION = "africa-south1";
const functions = getFunctions(app, FUNCTIONS_REGION);

export { app, db, functions };
